export const getViolationName = (type: number) => {
  let path = '-'

  switch (type) {
    case 0:
      path = 'violationName.drivingWithoutBreak'
      break
    case 1:
      path = 'violationName.oneWeekDrivingTime'
      break
    case 2:
      path = 'violationName.twoWeekDrivingTime'
      break
    case 3:
      path = 'violationName.dailyDrivingTime'
      break
    case 4:
      path = 'violationName.dailyRestTooShort'
      break
    case 5:
      path = 'violationName.dailyRestReceivedTooShort'
      break
    case 6:
      path = 'violationName.weekRestTime'
      break
    case 7:
      path = 'violationName.noWeekRestRecomponse'
      break
    case 8:
      path = 'violationName.tachographChartSwitchViolation'
      break
    case 9:
      path = 'violationName.tachographChartMultipleChartsUsed'
      break
    case 10:
      path = 'violationName.tachographChartDayExceededViolation'
      break
    case 11:
      path = 'violationName.tachographChartNotSupportedChart'
      break
    case 12:
      path = 'violationName.tachographChartDirtyChart'
      break
    case 13:
      path = 'violationName.tachographChartActivitiesPeriodViolation'
      break
    case 14:
      path = 'violationName.tachographChartNameOrSurnameViolation'
      break
    case 15:
      path = 'violationName.tachographChartRegistrationNumberViolation'
      break
    case 16:
      path = 'violationName.tachographChartStartDateViolation'
      break
    case 17:
      path = 'violationName.tachographChartEndDateViolation'
      break
    case 18:
      path = 'violationName.tachographChartOdometerStartViolation'
      break
    case 19:
      path = 'violationName.tachographChartOdometerEndViolation'
      break
    case 20:
      path = 'violationName.tachographChartTimeMismatchViolation'
      break
    case 21:
      path = 'violationName.tachographChartStartPlaceViolation'
      break
    case 22:
      path = 'violationName.tachographChartEndPlaceViolation'
      break
    case 23:
      path = 'violationName.missingDataStartEndPlaceViolation'
      break
    case 24:
      path = 'violationName.missingDataNoDataViolation'
      break
    case 25:
      path = 'violationName.missingDataStartEndPlaceNoDataViolation'
      break
    case 26:
      path = 'violationName.nightTimeWorkViolation'
      break
    case 27:
      path = 'violationName.weekRestTimeDistance'
      break
    case 28:
      path = 'violationName.noDataActivityViolation'
      break
    case 29:
      path = 'violationName.missingManualEntryPlaceViolation'
      break
    case 30:
      path = 'violationName.extendedWeekWorkTimeExceededViolation'
      break
    case 31:
      path = 'violationName.averageWeekWorkTimeExceededViolation'
      break
    case 32:
      path = 'violationName.dailyWorkingTimeWithoutBreak'
      break
    case 33:
      path = 'violationName.dailyWorkingTimeWithTooShortBreak'
      break
    case 34:
      path = 'violationName.manualDrivingViolation'
      break
    case 35:
      path = 'violationName.tachographChartMissingActivitiesViolation'
      break
    case 36:
      path = 'violationName.tachographChartEndCountryViolation'
      break
    case 37:
      path = 'violationName.tachographChartStartCountryViolation'
      break
    case 38:
      path = 'violationName.noHomeReturnViolation'
      break
    case 39:
      path = 'violationName.invalidFerryTrainViolation'
      break
    case 40:
      path = 'violationName.virtualDisplacement'
      break
  }

  return path
}
